module.exports = __webpack_public_path__ + "img/bg_hezuohuoban.9b8be0a8.png";